














import Vue from "vue";

interface Props {
  title: string;
}

export default Vue.extend<Props>({
  name: "JzDrillAnswerAreaCard",
  functional: true,

  props: {
    title: { type: String, default: "" }
  }
});
